// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://explorer.metis.io/address/0xEB0682d148e874553008730f0686ea89db7DA412
export const TRANSPARENT_PROXY_FACTORY = '0xEB0682d148e874553008730f0686ea89db7DA412';

// https://explorer.metis.io/address/0x1CabD986cBAbDf12E00128DFf03C80ee62C4fd97
export const PROXY_ADMIN = '0x1CabD986cBAbDf12E00128DFf03C80ee62C4fd97';

// https://explorer.metis.io/address/0x2e649f6b54B07E210b31c9cC2eB8a0d5997c3D4A
export const CREATE_3_FACTORY = '0x2e649f6b54B07E210b31c9cC2eB8a0d5997c3D4A';

// https://explorer.metis.io/address/0x56C1a4b54921DEA9A344967a8693C7E661D72968
export const PROTOCOL_GUARDIAN = '0x56C1a4b54921DEA9A344967a8693C7E661D72968';

// https://explorer.metis.io/address/0x8EC77963068474a45016938Deb95E603Ca82a029
export const LEGACY_BRIDGE_EXECUTOR = '0x8EC77963068474a45016938Deb95E603Ca82a029';

export const CHAIN_ID = 1088;
